
import { SideBarContainer, Icon, CloseIcon, SideBarMenu, SideBtnWrap, SideBarRoute, SideBarLink } from './SidebarElement'

const Sidebar = ({ isOpen, toggle }) => {
    return (
        <SideBarContainer isOpen={isOpen} onClick={toggle}>
            <Icon onClick={toggle}>
                <CloseIcon />
            </Icon>
            <SideBarMenu>
                <SideBarLink to="home">Noodles</SideBarLink>
                <SideBarLink to="dessert">dessert</SideBarLink>
                <SideBarLink to="/">Full Menu</SideBarLink>
            </SideBarMenu>
            <SideBtnWrap>
                <SideBarRoute to="/">Order Now</SideBarRoute>
            </SideBtnWrap>
        </SideBarContainer>
    )
}

export default Sidebar
